import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MobxAngularModule } from 'mobx-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './pages/home/home.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LayoutComponent } from './shared/layout/layout.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';
import { MaterialModule } from './modules/material.module';
import { AuthService } from './auth/auth.service';
import { APP_SERVICES } from './services/app.service';
import { NetInfoComponent } from './components/net-info/net-info.component';
import { HeaderComponent } from './shared/header/header.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { SignupComponent } from './pages/auth/signup/signup.component';
import { PrimaryButtonComponent } from './components/primary-button/primary-button.component';
import { HttpModule } from '@angular/http';
import { TabLayoutComponent } from './shared/tab-layout/tab-layout.component';
import { EmptyComponent } from './components/empty/empty.component';
import { AutofocusDirective } from './directives/auto-focus.directive';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { StickyPolyFillDirective } from './directives/sticky.directive';
import { PlaceholderComponent } from './components/placeholder/placeholder.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CancelComponent } from './components/cancel/cancel.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ResponsiveModule } from 'ngx-responsive'
import { AuthlayoutComponent } from './shared/authlayout/authlayout.component';
import { APP_STORES } from './stores/app.store';
import { LevelComponent } from './pages/resources/level/level.component';
import { LessonComponent } from './pages/resources/lesson/lesson.component';
import { TrainingModuleComponent } from './pages/resources/training-module/training-module.component';
import { TrainingActivityComponent } from './pages/resources/training-activity/training-activity.component';
import { LevelFormComponent } from './pages/resources/level/level-form/level-form.component';
import { QuillModule } from 'ngx-quill';
import { LessonFormComponent } from './pages/resources/lesson/lesson-form/lesson-form.component';
import { ProgramsComponent } from './pages/resources/programs/programs.component';
import { ProgramFormComponent } from './pages/resources/programs/program-form/program-form.component';
import { TrainingSkillComponent } from './pages/resources/training-module/training-skill/training-skill.component';
import { SentenceCompletionComponent } from './pages/resources/training-module/sentence-completion/sentence-completion.component';
import { SentenceCompletionListeningComponent } from './pages/resources/training-module/sentence-completion-listening/sentence-completion-listening.component';
import { SentenceCompletionGrammarComponent } from './pages/resources/training-module/sentence-completion-grammar/sentence-completion-grammar.component';
import { AddSentenceCompletionComponent } from './pages/resources/training-module/add-sentence-completion/add-sentence-completion.component';
import { ENTRY_COMPONENTS } from './modules/entry-component/entry-component.module';
import { TrainingModuleFormComponent } from './pages/resources/training-module/training-module-form/training-module-form.component';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';
import { AddSentenceCompletionBlankComponent } from './pages/resources/training-module/add-sentence-completion-blank/add-sentence-completion-blank.component';
import { DeleteComponent } from './components/delete/delete.component';
import { KeyVocabularyComponent } from './pages/resources/key-vocabulary/key-vocabulary.component';
import { AddKeyVocabularyComponent } from './pages/resources/key-vocabulary/add-key-vocabulary/add-key-vocabulary.component';
import { AddKeyVocabularyDefinitionComponent } from './pages/resources/key-vocabulary/add-key-vocabulary-definition/add-key-vocabulary-definition.component';
import { PictureDescriptionComponent } from './pages/resources/picture-description/picture-description.component';
import { GrammarComponent } from './pages/resources/grammar/grammar.component';
import { AddPictureQuestionComponent } from './pages/resources/picture-description/add-picture-question/add-picture-question.component';
import { MultipleChoiceQuestionComponent } from './pages/resources/multiple-choice-question/multiple-choice-question.component';
import { AddMultipleChoiceComponent } from './pages/resources/multiple-choice-question/add-multiple-choice/add-multiple-choice.component';
import { ConversationComponent } from './pages/resources/conversation/conversation.component';
import { AddSpeakerComponent } from './pages/resources/conversation/add-speaker/add-speaker.component';
import { AddConversationComponent } from './pages/resources/conversation/add-conversation/add-conversation.component';
import { MatchingExerciseComponent } from './pages/resources/matching-exercise/matching-exercise.component';
import { AddMatchingExerciseComponent } from './pages/resources/matching-exercise/add-matching-exercise/add-matching-exercise.component';
import { SentencePronunciationComponent } from './pages/resources/sentence-pronunciation/sentence-pronunciation.component';
import { AddSentencePronunciationComponent } from './pages/resources/sentence-pronunciation/add-sentence-pronunciation/add-sentence-pronunciation.component';
import { WordPronunciationComponent } from './pages/resources/word-pronunciation/word-pronunciation.component';
import { AddWordPronunciationComponent } from './pages/resources/word-pronunciation/add-word-pronunciation/add-word-pronunciation.component';
import { MatchingExerciseListeningComponent } from './pages/resources/matching-exercise/matching-exercise-listening/matching-exercise-listening.component';
import { MatchingExerciseGrammarComponent } from './pages/resources/matching-exercise/matching-exercise-grammar/matching-exercise-grammar.component';
import { WordClassComponent } from './pages/resources/word-class/word-class.component';
import { AddWordGroupComponent } from './pages/resources/word-class/add-word-group/add-word-group.component';
import { AddWordClassComponent } from './pages/resources/word-class/add-word-class/add-word-class.component';
import { GroupFilterPipe } from './pipes/group-filter.pipe';
import { WordClassGrammarComponent } from './pages/resources/word-class/word-class-grammar/word-class-grammar.component';
import { RewordingComponent } from './pages/resources/rewording/rewording.component';
import { AddRewordingComponent } from './pages/resources/rewording/add-rewording/add-rewording.component';
import { SenteceStructureComponent } from './pages/resources/sentece-structure/sentece-structure.component';
import { AddSenteceStructureComponent } from './pages/resources/sentece-structure/add-sentece-structure/add-sentece-structure.component';
import { DictationComponent } from './pages/resources/dictation/dictation.component';
import { AddDictationComponent } from './pages/resources/dictation/add-dictation/add-dictation.component';
import { HangmanComponent } from './pages/resources/hangman/hangman.component';
import { AddMultipleChoiceQuestionAnswerComponent } from './pages/resources/multiple-choice-question/add-multiple-choice-question-answer/add-multiple-choice-question-answer.component';
import { MultipleChoiceQuestionListeningComponent } from './pages/resources/multiple-choice-question/multiple-choice-question-listening/multiple-choice-question-listening.component';
import { MultipleChoiceQuestionGrammarComponent } from './pages/resources/multiple-choice-question/multiple-choice-question-grammar/multiple-choice-question-grammar.component';
import { CommonMistakesComponent } from './pages/resources/common-mistakes/common-mistakes.component';
import { InterestingArticleComponent } from './pages/resources/interesting-article/interesting-article.component';
import { ShortStoryComponent } from './pages/resources/short-story/short-story.component';
import { TongueTwisterComponent } from './pages/resources/tongue-twister/tongue-twister.component';
import { AddTongueTwisterComponent } from './pages/resources/tongue-twister/add-tongue-twister/add-tongue-twister.component';
import { BookstoreComponent } from './pages/bookstore/bookstore.component';
import { GenresComponent } from './pages/bookstore/genres/genres.component';
import { SectionsComponent } from './pages/bookstore/sections/sections.component';
import { TrendingComponent } from './pages/bookstore/trending/trending.component';
import { BooksComponent } from './pages/bookstore/books/books.component';
import { TrendingFormComponent } from './pages/bookstore/trending/trending-form/trending-form.component';
import { GenresFormComponent } from './pages/bookstore/genres/genres-form/genres-form.component';
import { SectionsFormComponent } from './pages/bookstore/sections/sections-form/sections-form.component';
import { BookFormComponent } from './pages/bookstore/books/book-form/book-form.component';
import { AuthorComponent } from './pages/bookstore/author/author.component';
import { AuthorFormComponent } from './pages/bookstore/author/author-form/author-form.component';
import { PublisherComponent } from './pages/bookstore/publisher/publisher.component';
import { PublisherFormComponent } from './pages/bookstore/publisher/publisher-form/publisher-form.component';
import { AngularEpubViewerModule } from 'angular-epub-viewer';
import { SlidesComponent } from './pages/bookstore/slides/slides.component';
import { SlideFormComponent } from './pages/bookstore/slides/slide-form/slide-form.component';
import { DictionaryComponent } from './pages/resources/dictionary/dictionary.component';
import { ProgramLevelComponent } from './pages/resources/programs/program-level/program-level.component';
import { ProgramLevelLessonComponent } from './pages/resources/programs/program-level-lesson/program-level-lesson.component';
import { DictionaryPageComponent } from './pages/dictionary/dictionary.component';
import { DictionaryFormComponent } from './pages/dictionary/dictionary-form/dictionary-form.component';
import { AddPosWordComponent } from './pages/dictionary/add-pos-word/add-pos-word.component';
import { AddProgramLevelComponent } from './pages/resources/programs/add-program-level/add-program-level.component';
import { DocRefPipe } from './pipes/doc-ref.pipe';
import { AddProgramLevelLessonComponent } from './pages/resources/programs/add-program-level-lesson/add-program-level-lesson.component';
import { ProgramLevelLessonModuleComponent } from './pages/resources/programs/program-level-lesson-module/program-level-lesson-module.component';
import { AddProgramLevelLessonModuleComponent } from './pages/resources/programs/add-program-level-lesson-module/add-program-level-lesson-module.component';
import { DictionaryDetailComponent } from './pages/dictionary/dictionary-detail/dictionary-detail.component';
import { EnrollmentComponent } from './pages/enrollment/enrollment.component';
import { AdmissionComponent } from './pages/enrollment/admission/admission.component';
import { ClassroomComponent } from './pages/enrollment/classroom/classroom.component';
import { StudentsComponent } from './pages/enrollment/students/students.component';
import { TutorComponent } from './pages/enrollment/tutor/tutor.component';
import { AdaptivePlacementTestComponent } from './pages/enrollment/adaptive-placement-test/adaptive-placement-test.component';
import { StudentFormComponent } from './pages/enrollment/students/student-form/student-form.component';
import { AddPictureDescriptionExerciseComponent } from './pages/resources/picture-description/add-picture-description-exercise/add-picture-description-exercise.component';
import { AddSenteceStructureExerciseComponent } from './pages/resources/sentece-structure/add-sentece-structure-exercise/add-sentece-structure-exercise.component';
import { AddHangmanComponent } from './pages/resources/hangman/add-hangman/add-hangman.component';
import { AddCommonMistakesComponent } from './pages/resources/common-mistakes/add-common-mistakes/add-common-mistakes.component';
import { GrammarInUseComponent } from './pages/resources/grammar-in-use/grammar-in-use.component';
import { GrammarSectionComponent } from './pages/resources/grammar-in-use/grammar-section/grammar-section.component';
import { GrammarSectionFormComponent } from './pages/resources/grammar-in-use/grammar-section-form/grammar-section-form.component';
import { GrammarLessonComponent } from './pages/resources/grammar-in-use/grammar-lesson/grammar-lesson.component';
import { GrammarLessonFormComponent } from './pages/resources/grammar-in-use/grammar-lesson-form/grammar-lesson-form.component';
import { GrammarContentFormComponent } from './pages/resources/grammar-in-use/grammar-content-form/grammar-content-form.component';
import { GrammarInUseExerciseComponent } from './pages/resources/grammar-in-use/grammar-in-use-exercise/grammar-in-use-exercise.component';
import { GrammarInUseExerciseFormComponent } from './pages/resources/grammar-in-use/grammar-in-use-exercise-form/grammar-in-use-exercise-form.component';
import { PlacementTestComponent } from './pages/testing-center/placement-test/placement-test.component';
import { AchievementTestComponent } from './pages/testing-center/achievement-test/achievement-test.component';
import { PlacementVocabularyComponent } from './pages/testing-center/placement-test/placement-vocabulary/placement-vocabulary.component';
import { AddPlacementVocabularyQuestionComponent } from './pages/testing-center/placement-test/add-placement-vocabulary-question/add-placement-vocabulary-question.component';
import { AddPlacementVocabularyQuizComponent } from './pages/testing-center/placement-test/add-placement-vocabulary-quiz/add-placement-vocabulary-quiz.component';
import { PlacementGrammarComponent } from './pages/testing-center/placement-test/placement-grammar/placement-grammar.component';
import { PlacementListeningComponent } from './pages/testing-center/placement-test/placement-listening/placement-listening.component';
import { PlacementReadingComponent } from './pages/testing-center/placement-test/placement-reading/placement-reading.component';
import { PlacementGrammarFormComponent } from './pages/testing-center/placement-test/placement-grammar-form/placement-grammar-form.component';
import { AddPlacementGrammarComponent } from './pages/testing-center/placement-test/add-placement-grammar/add-placement-grammar.component';
import { PlacementReadingFormComponent } from './pages/testing-center/placement-test/placement-reading-form/placement-reading-form.component';
import { AddPlacementReadingComponent } from './pages/testing-center/placement-test/add-placement-reading/add-placement-reading.component';
import { PlacementListeningFormComponent } from './pages/testing-center/placement-test/placement-listening-form/placement-listening-form.component';
import { AddPlacementListeningComponent } from './pages/testing-center/placement-test/add-placement-listening/add-placement-listening.component';
import { AddPlacementAnswerComponent } from './pages/testing-center/placement-test/add-placement-answer/add-placement-answer.component';
import { NgsPlacementTestComponent } from './pages/testing-center/ngs-placement-test/ngs-placement-test.component';
import { NgsPlacementFormComponent } from './pages/testing-center/ngs-placement-test/ngs-placement-form/ngs-placement-form.component';
import { MathPlacementComponent } from './pages/testing-center/ngs-placement-test/math-placement/math-placement.component';
import { McqGeneralPlacementComponent } from './pages/testing-center/ngs-placement-test/mcq-general-placement/mcq-general-placement.component';
import { AddMcqGeneralPlacementComponent } from './pages/testing-center/ngs-placement-test/add-mcq-general-placement/add-mcq-general-placement.component';
import { AddMcqGeneralPlacementAnswerComponent } from './pages/testing-center/ngs-placement-test/add-mcq-general-placement-answer/add-mcq-general-placement-answer.component';
import { NgxAudioPlayerModule } from 'ngx-audio-player';
import { KatexModule } from 'ng-katex';
import { BookClubComponent } from './pages/book-club/book-club.component';
import { MaterialBookClubComponent } from './pages/book-club/material-book-club/material-book-club.component';
import { AddMaterialBookClubComponent } from './pages/book-club/add-material-book-club/add-material-book-club.component';
import { ExerciseBookClubComponent } from './pages/book-club/exercise-book-club/exercise-book-club.component';
import { AddExerciseBookClubComponent } from './pages/book-club/add-exercise-book-club/add-exercise-book-club.component';
import { AddAnswerExerciseBookClubComponent } from './pages/book-club/add-answer-exercise-book-club/add-answer-exercise-book-club.component';
import { TutorFormComponent } from './pages/enrollment/tutor/tutor-form/tutor-form.component';
import { RegisterTestComponent } from './pages/enrollment/register-test/register-test.component';
import { AddClassroomComponent } from './pages/enrollment/classroom/add-classroom/add-classroom.component';
import { GeoDataComponent } from './pages/list/geo-data/geo-data.component';
import { AddCountryComponent } from './pages/list/geo-data/add-country/add-country.component';
import { GeoDistrictComponent } from './pages/list/geo-data/geo-district/geo-district.component';
import { AddGeoDistrictComponent } from './pages/list/geo-data/add-geo-district/add-geo-district.component';
import { GeoAnalyticsComponent } from './pages/list/geo-data/geo-analytics/geo-analytics.component';
import { GeoProvinceComponent } from './pages/list/geo-data/geo-province/geo-province.component';
import { AddGeoProvinceComponent } from './pages/list/geo-data/add-geo-province/add-geo-province.component';
import { HolidayComponent } from './pages/list/holiday/holiday.component';
import { AddHolidayComponent } from './pages/list/holiday/add-holiday/add-holiday.component';
import { ShiftComponent } from './pages/list/shift/shift.component';
import { AddShiftComponent } from './pages/list/shift/add-shift/add-shift.component';
import { SessionComponent } from './pages/list/shift/session/session.component';
import { AddSessionComponent } from './pages/list/shift/add-session/add-session.component';
import { TermComponent } from './pages/list/shift/term/term.component';
import { AddTermComponent } from './pages/list/shift/add-term/add-term.component';
import { SubjectComponent } from './pages/list/subject/subject.component';
import { AddSubjectComponent } from './pages/list/subject/add-subject/add-subject.component';
import { AddProgramComponent } from './pages/list/programs/add-program/add-program.component';
import { DegreeComponent } from './pages/list/degree/degree.component';
import { AddDegreeComponent } from './pages/list/degree/add-degree/add-degree.component';
import { AddLevelComponent } from './pages/list/level/add-level/add-level.component';
import { TrainingLevelComponent } from './pages/list/training-level/training-level.component';
import { AddTrainingLevelComponent } from './pages/list/training-level/add-training-level/add-training-level.component';
import { TrainingProgramComponent } from './pages/list/training-program/training-program.component';
import { AddTrainingProgramComponent } from './pages/list/training-program/add-training-program/add-training-program.component';
import { SettingComponent } from './pages/list/setting/setting.component';
import { NationalityComponent } from './pages/list/nationality/nationality.component';
import { AddNationalityComponent } from './pages/list/nationality/add-nationality/add-nationality.component';
import { LecturersComponent } from './pages/list/lecturers/lecturers.component';
import { AddLecturersComponent } from './pages/list/lecturers/add-lecturers/add-lecturers.component';
import { CampusComponent } from './pages/list/campus/campus.component';
import { AddCampusComponent } from './pages/list/campus/add-campus/add-campus.component';
import { RoomComponent } from './pages/list/room/room.component';
import { AddRoomComponent } from './pages/list/room/add-room/add-room.component';
import { BuildingComponent } from './pages/list/building/building.component';
import { AddBuildingComponent } from './pages/list/building/add-building/add-building.component';
import { FloorComponent } from './pages/list/floor/floor.component';
import { AddFloorComponent } from './pages/list/floor/add-floor/add-floor.component';
import { TuitionFeeComponent } from './pages/list/tuition-fee/tuition-fee.component';
import { RoomTypesComponent } from './pages/list/room-types/room-types.component';
import { AddRoomTypeComponent } from './pages/list/room-types/add-room-type/add-room-type.component';
import { LectureTypeComponent } from './pages/list/lecture-type/lecture-type.component';
import { AddLectureTypeComponent } from './pages/list/lecture-type/add-lecture-type/add-lecture-type.component';
import { FacultyComponent } from './pages/list/faculty/faculty.component';
import { AddFacultyComponent } from './pages/list/faculty/add-faculty/add-faculty.component';
import { FacultyPanelComponent } from './pages/list/faculty/faculty-panel/faculty-panel.component';
import { AddMajorComponent } from './pages/list/faculty/add-major/add-major.component';
import { MajorComponent } from './pages/list/faculty/major/major.component';
import { FacultyOverviewComponent } from './pages/list/faculty/faculty-overview/faculty-overview.component';
import { CurriculaComponent } from './pages/list/faculty/curricula/curricula.component';
import { AddCurricularComponent } from './pages/list/faculty/add-curricular/add-curricular.component';
import { CourseTypeComponent } from './pages/list/course-type/course-type.component';
import { AddCourseTypeComponent } from './pages/list/course-type/add-course-type/add-course-type.component';
import { CurriculumComponent } from './pages/list/faculty/curriculum/curriculum.component';
import { CurriculumCourseComponent } from './pages/list/faculty/curriculum-course/curriculum-course.component';
import { AddCurriculumCourseComponent } from './pages/list/faculty/add-curriculum-course/add-curriculum-course.component';
import { HeaderTabsComponent } from './components/header-tabs/header-tabs.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LazyLoadingComponent } from './components/lazy-loading/lazy-loading.component';
import { WariningContainerComponent } from './components/warining-container/warining-container.component';
import { DisplayNamePipe } from './pipes/display-name.pipe';
import { FilterDataPipe } from './pipes/filter-data.pipe';
import { RouteLayoutComponent } from './shared/route-layout/route-layout.component';
import { APP_ENTRIES } from './modules/app.entries';
import { ADProgramsComponent } from './pages/list/programs/programs.component';
import { ADLevelComponent } from './pages/list/level/level.component';
import { AddNewTestingComponent } from './components/add-new-testing/add-new-testing.component';
import { InvoicePaymentComponent } from './components/invoice-payment/invoice-payment.component';
import { ClassroomPanelComponent } from './pages/enrollment/classroom/classroom-panel/classroom-panel.component';
import { ClassroomStudentComponent } from './pages/enrollment/classroom/classroom-student/classroom-student.component';
import { ProgramAchievementTestComponent } from './pages/resources/programs/program-achievement-test/program-achievement-test.component';
import { ProgramReadingComponent } from './pages/resources/programs/program-reading/program-reading.component';
import { AddProgramReadingComponent } from './pages/resources/programs/add-program-reading/add-program-reading.component';
import { ProgramAchievementTestVocabularyComponent } from './pages/resources/programs/program-achievement-test-vocabulary/program-achievement-test-vocabulary.component';
import { ProgramAchievementTestGrammarComponent } from './pages/resources/programs/program-achievement-test-grammar/program-achievement-test-grammar.component';
import { ProgramAchievementTestReadingComponent } from './pages/resources/programs/program-achievement-test-reading/program-achievement-test-reading.component';
import { ProgramAchievementTestListeningComponent } from './pages/resources/programs/program-achievement-test-listening/program-achievement-test-listening.component';
import { RegisterTestFormComponent } from './pages/enrollment/register-test-form/register-test-form.component';
import { AddRegisterTestResultComponent } from './pages/enrollment/register-test/add-register-test-result/add-register-test-result.component';
import { ScheduleComponent } from './pages/enrollment/schedule/schedule.component';
import { AddScheduleComponent } from './pages/enrollment/schedule/add-schedule/add-schedule.component';
import { UpdateScheduleComponent } from './pages/enrollment/schedule/update-schedule/update-schedule.component';
import { EnrollReadingComponent } from './pages/enrollment/enroll-reading/enroll-reading.component';
import { AddEnrollReadingComponent } from './pages/enrollment/enroll-reading/add-enroll-reading/add-enroll-reading.component';
import { ApiService } from './services/api.service';
import { HttpClientModule } from '@angular/common/http';
import { ReadingClubComponent } from './pages/reading-club/reading-club.component';
import { ReadingLevelComponent } from './pages/reading-club/reading-level/reading-level.component';
import { ReadingWordsComponent } from './pages/reading-club/reading-words/reading-words.component';
import { ReadingTypeComponent } from './pages/reading-club/reading-type/reading-type.component';
import { ReadingFormatComponent } from './pages/reading-club/reading-format/reading-format.component';
import { ReadingTargetAgeComponent } from './pages/reading-club/reading-target-age/reading-target-age.component';
import { ReadingEnglishTypeComponent } from './pages/reading-club/reading-english-type/reading-english-type.component';
import { AddReadingLevelComponent } from './pages/reading-club/add-reading-level/add-reading-level.component';
import { AddReadingClubComponent } from './pages/reading-club/add-reading-club/add-reading-club.component';
import { AddReadingTargetAgeComponent } from './pages/reading-club/add-reading-target-age/add-reading-target-age.component';
import { AddReadingTypeComponent } from './pages/reading-club/add-reading-type/add-reading-type.component';
import { AddReadingAudioBookComponent } from './pages/reading-club/add-reading-audio-book/add-reading-audio-book.component';
import { AddReadingTextConvertorComponent } from './pages/reading-club/add-reading-text-convertor/add-reading-text-convertor.component';
import { AppCenterComponent } from './pages/app-center/app-center.component';
import { AppSlideComponent } from './pages/app-center/app-slide/app-slide.component';
import { AddAppSlideComponent } from './pages/app-center/add-app-slide/add-app-slide.component';
import { AppVideoComponent } from './pages/app-center/app-video/app-video.component';
import { AddAppVideoComponent } from './pages/app-center/add-app-video/add-app-video.component';
import { NgxYoutubePlayerModule } from "ngx-youtube-player";
import { DateOnlyPipe, OrderDataPipe } from './pipes/order-data.pipe';
import { TrainingComponent } from './pages/training/training.component';
import { TrainingStudentComponent } from './pages/training/training-student/training-student.component';
import { EmptyDataComponent } from './components/empty-data/empty-data.component';
import { AddTrainingStudentComponent } from './pages/training/add-training-student/add-training-student.component';
import { AddTrainingAdminssionComponent } from './pages/training/add-training-adminssion/add-training-adminssion.component';
import { TrainingTutorComponent } from './pages/training/training-tutor/training-tutor.component';
import { AddTrainingTutorComponent } from './pages/training/add-training-tutor/add-training-tutor.component';
import { TrainingBatchesComponent } from './pages/training/training-batches/training-batches.component';
import { AddTrainingBatchComponent } from './pages/training/add-training-batch/add-training-batch.component';
import { TrainingSupportComponent } from './pages/training/training-support/training-support.component';
import { TrainingTrailAccountComponent } from './pages/training/training-trail-account/training-trail-account.component';
import { TrainingRegisterTestComponent } from './pages/training/training-register-test/training-register-test.component';
import { NewAndTrendingComponent } from './pages/bookstore/new-and-trending/new-and-trending.component';
import { AddNewAndTrendingComponent } from './pages/bookstore/add-new-and-trending/add-new-and-trending.component';
import { DocRefDisplayComponent } from './components/doc-ref-display/doc-ref-display.component';
import { ReadingUserComponent } from './pages/reading-club/reading-user/reading-user.component';
import { AddReadingUserComponent } from './pages/reading-club/reading-user/add-reading-user/add-reading-user.component';
import { ReadingBatchComponent } from './pages/reading-club/reading-batch/reading-batch.component';
import { AddReadingBatchComponent } from './pages/reading-club/reading-batch/add-reading-batch/add-reading-batch.component';
import { ReadingBatchLevelComponent } from './pages/reading-club/reading-batch-level/reading-batch-level.component';
import { AddReadingBatchLevelComponent } from './pages/reading-club/reading-batch-level/add-reading-batch-level/add-reading-batch-level.component';
import { ReadingBatchLevelStudentComponent } from './pages/reading-club/reading-batch-level-student/reading-batch-level-student.component';
import { AddBatchLevelStudentComponent } from './pages/reading-club/reading-batch-level-student/add-batch-level-student/add-batch-level-student.component';
import { SchoolsComponent } from './pages/reading-club/schools/schools.component';
import { SchoolFormComponent } from './pages/reading-club/schools/school-form/school-form.component';
import { FindLevelPipe } from './pipes/find-level.pipe';
import { IntroductionDialogueComponent } from './pages/resources/introduction-dialogue/introduction-dialogue.component';
import { PictureDescriptionSpeakingComponent } from './pages/resources/picture-description-speaking/picture-description-speaking.component';
import { AddAnswerRewordingComponent } from './pages/resources/rewording/add-answer-rewording/add-answer-rewording.component';
import { ImportCamReadingStudentComponent } from './pages/reading-club/import-cam-reading-student/import-cam-reading-student.component';
import { AcademicYearComponent } from './pages/reading-club/academic-year/academic-year.component';
import { AddYearComponent } from './pages/reading-club/academic-year/add-year/add-year.component';
import { ResolveDataComponent } from './pages/reading-club/resolve-data/resolve-data.component';
import { EditYearComponent } from './pages/reading-club/academic-year/edit-year/edit-year.component';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  // suppressScrollX: true
  wheelPropagation: true
};

@NgModule({
  declarations: [
    InvoicePaymentComponent,
    AddNewTestingComponent,
    ADLevelComponent,
    RouteLayoutComponent,
    DisplayNamePipe,
    FilterDataPipe,
    WariningContainerComponent,
    HeaderTabsComponent,
    DictionaryComponent,
    DictionaryFormComponent,
    AppComponent,
    HomeComponent,
    DashboardComponent,
    StickyPolyFillDirective,
    LayoutComponent,
    NetInfoComponent,
    HeaderComponent,
    SidebarComponent,
    LoginComponent,
    SignupComponent,
    PrimaryButtonComponent,
    TabLayoutComponent,
    EmptyComponent,
    AutofocusDirective,
    SpinnerComponent,
    PlaceholderComponent,
    CancelComponent,
    AuthlayoutComponent,
    LevelComponent,
    LessonComponent,
    TrainingModuleComponent,
    TrainingActivityComponent,
    LevelFormComponent,
    LessonFormComponent,
    ProgramsComponent,
    ADProgramsComponent,
    ProgramFormComponent,
    TrainingSkillComponent,
    SentenceCompletionComponent,
    SentenceCompletionListeningComponent,
    SentenceCompletionGrammarComponent,
    AddSentenceCompletionComponent,
    TrainingModuleFormComponent,
    SanitizeHtmlPipe,
    AddSentenceCompletionBlankComponent,
    DeleteComponent,
    KeyVocabularyComponent,
    AddKeyVocabularyComponent,
    AddKeyVocabularyDefinitionComponent,
    PictureDescriptionComponent,
    GrammarComponent,
    AddPictureQuestionComponent,
    MultipleChoiceQuestionComponent,
    AddMultipleChoiceComponent,
    ConversationComponent,
    AddSpeakerComponent,
    AddConversationComponent,
    MatchingExerciseComponent,
    AddMatchingExerciseComponent,
    SentencePronunciationComponent,
    AddSentencePronunciationComponent,
    WordPronunciationComponent,
    AddWordPronunciationComponent,
    MatchingExerciseListeningComponent,
    MatchingExerciseGrammarComponent,
    WordClassComponent,
    AddWordGroupComponent,
    AddWordClassComponent,
    GroupFilterPipe,
    WordClassGrammarComponent,
    RewordingComponent,
    AddRewordingComponent,
    SenteceStructureComponent,
    AddSenteceStructureComponent,
    DictationComponent,
    AddDictationComponent,
    HangmanComponent,
    AddMultipleChoiceQuestionAnswerComponent,
    MultipleChoiceQuestionListeningComponent,
    MultipleChoiceQuestionGrammarComponent,
    CommonMistakesComponent,
    InterestingArticleComponent,
    ShortStoryComponent,
    TongueTwisterComponent,
    AddTongueTwisterComponent,
    BookstoreComponent,
    GenresComponent,
    SectionsComponent,
    TrendingComponent,
    BooksComponent,
    TrendingFormComponent,
    GenresFormComponent,
    SectionsFormComponent,
    BookFormComponent,
    AuthorComponent,
    AuthorFormComponent,
    PublisherComponent,
    PublisherFormComponent,
    SlidesComponent,
    SlideFormComponent,
    DictionaryComponent,
    DictionaryPageComponent,
    ProgramLevelComponent,
    ProgramLevelLessonComponent,
    AddPosWordComponent,
    AddProgramLevelComponent,
    DocRefPipe,
    AddProgramLevelLessonComponent,
    ProgramLevelLessonModuleComponent,
    AddProgramLevelLessonModuleComponent,
    DictionaryDetailComponent,
    EnrollmentComponent,
    AdmissionComponent,
    ClassroomComponent,
    StudentsComponent,
    TutorComponent,
    AdaptivePlacementTestComponent,
    StudentFormComponent,
    AddPictureDescriptionExerciseComponent,
    AddSenteceStructureExerciseComponent,
    AddHangmanComponent,
    AddCommonMistakesComponent,
    GrammarInUseComponent,
    GrammarSectionComponent,
    GrammarSectionFormComponent,
    GrammarLessonComponent,
    GrammarLessonFormComponent,
    GrammarContentFormComponent,
    GrammarInUseExerciseComponent,
    GrammarInUseExerciseFormComponent,
    PlacementTestComponent,
    AchievementTestComponent,
    PlacementVocabularyComponent,
    AddPlacementVocabularyQuestionComponent,
    AddPlacementVocabularyQuizComponent,
    PlacementGrammarComponent,
    PlacementListeningComponent,
    PlacementReadingComponent,
    PlacementGrammarFormComponent,
    AddPlacementGrammarComponent,
    PlacementReadingFormComponent,
    AddPlacementReadingComponent,
    PlacementListeningFormComponent,
    AddPlacementListeningComponent,
    AddPlacementAnswerComponent,
    NgsPlacementTestComponent,
    NgsPlacementFormComponent,
    MathPlacementComponent,
    McqGeneralPlacementComponent,
    AddMcqGeneralPlacementComponent,
    AddMcqGeneralPlacementAnswerComponent,
    TutorFormComponent,
    RegisterTestComponent,
    AddClassroomComponent,
    BookClubComponent,
    MaterialBookClubComponent,
    AddMaterialBookClubComponent,
    ExerciseBookClubComponent,
    AddExerciseBookClubComponent,
    AddAnswerExerciseBookClubComponent,

    GeoDataComponent,
    AddCountryComponent,
    GeoDistrictComponent,
    AddGeoDistrictComponent,
    GeoAnalyticsComponent,
    GeoProvinceComponent,
    AddGeoProvinceComponent,
    HolidayComponent,
    AddHolidayComponent,
    ShiftComponent,
    AddShiftComponent,
    SessionComponent,
    AddSessionComponent,
    TermComponent,
    AddTermComponent,
    SubjectComponent,
    AddSubjectComponent,
    AddProgramComponent,
    DegreeComponent,
    AddDegreeComponent,
    LevelComponent,
    AddLevelComponent,
    TrainingLevelComponent,
    AddTrainingLevelComponent,
    TrainingProgramComponent,
    AddTrainingProgramComponent,
    SettingComponent,
    NationalityComponent,
    AddNationalityComponent,
    LecturersComponent,
    AddLecturersComponent,
    CampusComponent,
    AddCampusComponent,
    RoomComponent,
    AddRoomComponent,
    BuildingComponent,
    AddBuildingComponent,
    FloorComponent,
    AddFloorComponent,
    TuitionFeeComponent,
    RoomTypesComponent,
    AddRoomTypeComponent,
    LectureTypeComponent,
    AddLectureTypeComponent,
    FacultyComponent,
    AddFacultyComponent,
    FacultyPanelComponent,
    AddMajorComponent,
    MajorComponent,
    FacultyOverviewComponent,
    CurriculaComponent,
    AddCurricularComponent,
    CourseTypeComponent,
    AddCourseTypeComponent,
    CurriculumComponent,
    CurriculumCourseComponent,
    AddCurriculumCourseComponent,
    LazyLoadingComponent,
    ClassroomPanelComponent,
    ClassroomStudentComponent,
    ProgramAchievementTestComponent,
    ProgramReadingComponent,
    AddProgramReadingComponent,
    ProgramAchievementTestVocabularyComponent,
    ProgramAchievementTestGrammarComponent,
    ProgramAchievementTestReadingComponent,
    ProgramAchievementTestListeningComponent,
    RegisterTestFormComponent,
    AddRegisterTestResultComponent,
    ScheduleComponent,
    AddScheduleComponent,
    UpdateScheduleComponent,
    EnrollReadingComponent,
    AddEnrollReadingComponent,
    ReadingClubComponent,
    ReadingLevelComponent,
    ReadingWordsComponent,
    ReadingTypeComponent,
    ReadingFormatComponent,
    ReadingTargetAgeComponent,
    ReadingEnglishTypeComponent,
    AddReadingLevelComponent,
    AddReadingClubComponent,
    AddReadingTargetAgeComponent,
    AddReadingTypeComponent,
    AddReadingAudioBookComponent,
    AddReadingTextConvertorComponent,
    AppCenterComponent,
    AppSlideComponent,
    AddAppSlideComponent,
    AppVideoComponent,
    AddAppVideoComponent,
    OrderDataPipe,
    TrainingComponent,
    TrainingStudentComponent,
    EmptyDataComponent,
    AddTrainingStudentComponent,
    AddTrainingAdminssionComponent,
    TrainingTutorComponent,
    AddTrainingTutorComponent,
    TrainingBatchesComponent,
    AddTrainingBatchComponent,
    TrainingSupportComponent,
    TrainingTrailAccountComponent,
    TrainingRegisterTestComponent,
    NewAndTrendingComponent,
    AddNewAndTrendingComponent,
    DocRefDisplayComponent,
    ReadingUserComponent,
    AddReadingUserComponent,
    ReadingBatchComponent,
    AddReadingBatchComponent,
    ReadingBatchLevelComponent,
    AddReadingBatchLevelComponent,
    ReadingBatchLevelStudentComponent,
    AddBatchLevelStudentComponent,
    SchoolsComponent,
    SchoolFormComponent,
    FindLevelPipe,
    IntroductionDialogueComponent,
    PictureDescriptionSpeakingComponent,
    AddAnswerRewordingComponent,
    ImportCamReadingStudentComponent,
    AcademicYearComponent,
    AddYearComponent,
    DateOnlyPipe,
    ResolveDataComponent,
    EditYearComponent
  ],
  entryComponents: [
    CancelComponent,
    ENTRY_COMPONENTS,
    AddPosWordComponent,
    GrammarSectionFormComponent,
    APP_ENTRIES
  ],
  imports: [
    NgxAudioPlayerModule,
    KatexModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MobxAngularModule,
    AngularEpubViewerModule,
    AngularFireModule.initializeApp(environment.firebase, ''),
    AngularFirestoreModule,
    AngularFireAuthModule,
    AngularFireStorageModule,
    MaterialModule,
    HttpModule,
    InfiniteScrollModule,
    PerfectScrollbarModule,
    QuillModule.forRoot(),
    ResponsiveModule.forRoot(),
    NgbModule,
    HttpClientModule,
    NgxYoutubePlayerModule,
    VirtualScrollerModule,
  ],
  providers: [
    APP_SERVICES,
    APP_STORES,
    BnNgIdleService,
    ApiService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
